<template>
  <div id="add-topik">
    <form action="#" v-on:submit.prevent="submitForm">
      <div class="form-group" id="add-topik-modal-select">
        <label for="inputTopik">Nama Topik</label>
        <select
          name="topik"
          id="selectTopik"
          v-model="selected_topic"
          class="form-control"
        ></select>
      </div>
      <div class="form-group">
        <label for="inputKeyword"
          >Kata Kunci <span class="text-danger">*</span></label
        >
        <input
          type="text"
          id="inputKeyword"
          name="keyword"
          required
          v-model="input_keyword"
          class="form-control"
          placeholder="Masukkan Keyword"
        />
        <small class="text-muted">
          <i class="bi bi-info-circle mr-1"></i> Gunakan tanda kutip untuk
          menjadikan kata kunci sebagai frasa
        </small>
      </div>
      <div class="form-group">
        <label for="inputExclude">Pengecualian</label>
        <input
          type="text"
          id="inputExclude"
          name="exclude"
          v-model="input_exclude"
          class="form-control"
          placeholder="Masukkan Exclude"
        />
        <small class="text-muted">
          <i class="bi bi-info-circle mr-1"></i> Kata kunci yang dikecualikan akan
          dianggap sebagai frasa, gunakan koma untuk memisahkan setiap kata kunci
        </small>
      </div>
      <div class="form-group" align="right">
        <button type="button" class="btn btn-danger m-r-5" data-dismiss="modal">
          Batal
        </button>
        <button type="submit" class="btn btn-warning" :disabled="is_loading">
          Simpan
        </button>
      </div>
    </form>
    <floating-loader-component v-if="is_floating_loading" />
  </div>
</template>

<script>
import $ from "jquery";
import notif from "@/assets/js/notif.js";
import floating_loader from "@/views/components/floating_loader.vue";

$.pgNotification = notif;
export default {
  name: "modal_edit_keyword",
  props: {
    data: Array,
  },
  components: {
    "floating-loader-component": floating_loader,
  },
  data() {
    return {
      err: null,
      selected_topic: this.data["topic_id"],
      old_topic: this.data["topic_id"],
      input_keyword: this.data["keyword"],
      old_keyword: this.data["keyword"],
      input_exclude: this.data["excludes"],
      tipe: this.data["tipe"],
      callback: "callback" in this.data ? this.data["callback"] : null,
      id_project: this.$route.query.ref
        ? parseInt(atob(this.$route.query.ref))
        : this.$store.getters.user.id_project,
      is_loading: false,
      is_floating_loading: false,
    };
  },
  methods: {
    getTopic: function () {
      let self = this;
      let api =
        process.env.VUE_APP_API_URL + "display-topics/" + this.id_project;
      this.is_loading = true;
      this.$http
        .get(api)
        .then(function (response) {
          if (response.status != 204) {
            let data = {};
            let topic_list =
              self.tipe == 1 ? response.data.socmed : response.data.formed;
            for (let topic in topic_list) {
              data = {
                id: topic,
                text: topic_list[topic],
              };
              let newOption = new Option(data.text, data.id, false, false);
              $("#selectTopik").append(newOption);
            }
            $("#selectTopik").val(self.selected_topic);
            $("#selectTopik").trigger("change");
            self.is_loading = false;
          }
        })
        .catch(function (err) {
          self.err = err.response;
        })
        .finally(function () {
          $("#selectTopik")
            .select2({
              width: "100%",
              dropdownParent: $('#modalSlideUp')
            })
            .on("change", function () {
              self.selectTopic(this.value);
            });
        });
    },
    selectTopic: function (value) {
      this.selected_topic = value;
    },
    submitForm: function () {
      let self = this;
      self.$store.dispatch("loading", true);
      let params = {
        old_keyword: this.$sanitize(this.old_keyword),
        old_id: this.$sanitize(this.old_topic),
        keyword: this.$sanitize(this.input_keyword),
        excludes: this.input_exclude ? this.$sanitize(this.input_exclude) : "",
        _id: this.selected_topic,
        tipe: parseInt(this.tipe),
      };
      let api = process.env.VUE_APP_API_URL + "new-keyword-update";
      let notif_position = "top";
      if ("ref" in this.data) {
        if (this.data["ref"] == "admin") {
          notif_position = "top-right";
        }
      }
      this.is_floating_loading = true;
      this.$http
        .post(api, params)
        .then(function (response) {
          if (response.status == 200) {
            if (self.callback) {
              self.callback()
            }
            self.$parent.$parent.getKeyword();
            self.topik = null;
            $("#modalSlideUp").modal("hide");
            self.$store.dispatch("loading", false);
            $("body")
              .pgNotification({
                style: "bar",
                message:
                  '<i class="bi bi-check-circle"></i> <b>Berhasil!</b> Keyword berhasil diubah.',
                position: notif_position,
                timeout: 5000,
                type: "success",
              })
              .show();
          }
        })
        .catch(function () {
          $("#modalSlideUp").modal("hide");
          self.$store.dispatch("loading", false);
          $("body")
            .pgNotification({
              style: "bar",
              message:
                '<i class="bi bi-x-circle"></i> <b>Error!</b> Terjadi kesalahan pada saat mengubah Keyword!',
              position: notif_position,
              timeout: 5000,
              type: "danger",
            })
            .show();
        })
        .finally(() => {
          this.is_floating_loading = false;
        });
    },
  },
  mounted: function () {
    this.getTopic();
  },
};
</script>

<style scoped>
.form-control {
  -webkit-appearance: button;
  cursor: pointer;
}
#add-topik-modal-select > .select2-container {
  width: 100% !important;
}
</style>
